import React from "react";
import { Tabs, Tab, Chip, Box, useMediaQuery, Theme } from "@mui/material";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

interface Status {
  label: string;
  name: string;
  total: number;
  color?: string;
  bg?: string;
}

interface Props {
  statuses: Status[];
  selectedStatus: string | null;
  orderTotal: number;
  handleTabChange: (event: React.SyntheticEvent, newValue: string) => void;
}

const StatusTabs: React.FC<Props> = ({
  statuses,
  selectedStatus,
  orderTotal,
  handleTabChange,
}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  const isTablet = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  return (
    <Tabs
      value={selectedStatus || null}
      onChange={handleTabChange}
      textColor="primary"
      variant={isMobile ? "scrollable" : isTablet ? "scrollable" : "standard"}
      scrollButtons={isMobile ? "auto" : isTablet ? "auto" : undefined}
      sx={{
        borderBottom: "1px solid #e6e6e6",
        maxWidth: isMobile ? 350 : isTablet ? 700 : "Calc(100vw - 200px)",
        mb: 2,
        "& .MuiTabs-indicator": {
          backgroundColor: "#000",
        },
        "& .MuiTab-root": {
          fontSize: isMobile ? "0.8rem" : "1rem",
          minWidth: isMobile ? "auto" : 120,
          padding: isMobile ? "6px 12px" : "12px 16px",
        },
      }}
    >
      {/* All Tab */}
      <Tab
        label={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <span style={{ fontWeight: "bold", color: "#000" }}>
              {t("general.All")}
            </span>
            <Chip
              label={orderTotal}
              sx={{
                backgroundColor: "#ccc",
                color: "#644980",
                fontWeight: "bold",
                minWidth: 30,
              }}
              size="small"
            />
          </Box>
        }
        value={null}
      />

      {/* Status Tabs */}
      {statuses.map((status) => (
        <Tab
          key={status.name}
          value={status.name}
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <span style={{ fontWeight: "bold", color: "#000" }}>
                {status.label}
              </span>
              <Chip
                label={status.total}
                sx={{
                  backgroundColor: status.bg ?? "#d0b7ea",
                  color: status.color ?? "#644980",
                  fontWeight: "bold",
                  minWidth: 30,
                }}
                size="small"
              />
            </Box>
          }
        />
      ))}
    </Tabs>
  );
};

export default StatusTabs;
